// import { routerMiddleware } from 'connected-react-router';
import Axios from 'axios'
import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import appReducers from './reducers'

// Axios stuff - this probably isn't the best place for this
Axios.interceptors.request.use((config) => {
    // console.log(config)
    if (!config.headers.Authorization)
        config.headers.Authorization = store.getState().auth.token

    config.baseURL = 'https://idea.boss.siemens.cloud/'
    return config
})


// -----------

const persistConfig = {
    key: 'root',
    storage,
    migrate: (state) => {
        return Promise.resolve(state)
    },
}

export const history = createBrowserHistory()

const persistedReducer = persistReducer(persistConfig, appReducers())

function configureStore(preloadedState) {
    const store = createStore(
        persistedReducer,
        preloadedState,
        composeWithDevTools(applyMiddleware(thunk))
    )
    return store
}

export const store = configureStore({})
export const persistor = persistStore(store)
